<template>
  <section class="content">
    <div class="center-block">
      <!--<h2>Data tables</h2>-->
      <div>
        <div class="box" style="padding: 50px">
          <!-- /.box-header -->
          <div class="warning-info">
            <div><span class="text-red">＊</span>請選擇欲建立的折扣類型，按下新增後進入編輯。</div>
            <div><span class="text-red">＊</span>若同時有兩檔現折活動，訂單若同時符合條件，會以先設定的現折活動為優先套用（消費者不可選擇）。</div>
            <div>
              <span class="text-red">＊</span>
              <span>
                「現折活動」與其他優惠活動併用規則請
                <a
                  href="https://docs.google.com/spreadsheets/d/1_nFqJPrfvsNEvTXBTHKeSrm9oYwJc4-BPFK6ocBo-bg/edit#gid=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  v-text="'點我開啟'"
                />。
              </span>
            </div>
          </div>
          <div class="row">
            <template v-for="(item, index) in list">
            <div :class="['col-md-6']" :key="'index'+index">
              <div :class="['info-block', `bg-light-${item.color}`]">
                <div :class="[`bg-${item.color}`, 'order-block text-center title subNumber']">{{index + 1}}</div>
                <div :class="['discount-block', `bg-light-${item.color}`]">
                  <div class="flex discount-inside-block">
                    <div>
                      <div class="title">{{item.title}}</div>
                      <div class="desciption">{{item.desciption}}</div>
                    </div>
                    <div class="edit-block">
                      <router-link :to="'/crDiscount?rule_code='+item.link">
                        <button class="btn btn-black">新增</button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      activityMethod: 1,
      list: [
        {
          title: '指定商品X份折Y元',
          desciption: '範例 : 買「綠茶」2杯，可折5元',
          color: 'warning',
          link: 'SD00002'
        },
        {
          title: '買X份商品送Y份商品',
          desciption: '範例 : 買5杯送1杯(滿6杯贈送最低價那杯)',
          color: 'danger',
          link: 'SD00003'
        },
        {
          title: '訂單打X折',
          desciption: '範例 : 訂單打8折',
          color: 'success',
          link: 'SD00004'
        },
        {
          title: '買X份商品折Y元',
          desciption: '範例 : 買5份商品折20元',
          color: 'primary',
          link: 'SD00005'
        }
      ]
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>

<style lang="sass" scoped>
  .bg-primary
    background: #4298BB;
    color: #FFF
  .bg-light-primary
    background: #52BEEA;
    color: #FFF
  .bg-warning
    background: #BA7F30;
    color: #FFF
  .bg-light-warning
    background: #E89F3C;
    color: #FFF
  .bg-success
    background: #3B814E;
    color: #FFF
  .bg-light-success
    background: #4AA261;
    color: #FFF
  .bg-danger
    background: #A54535
    color: #FFF
  .bg-light-danger
    background: #CE5542;
    color: #FFF
  .info-block
    display: flex
    margin-right: 37px
    margin-top: 41px
  .order-block
    width: 76px
    line-height: 127px
  .discount-block
    width: 100%
    padding: 0px 25px;
    margin: auto 0px;
  .flex
    display: flex
  .title
      font-size: 24px
  .desciption
      font-size: 16px
  .edit-block
    margin: auto 0px auto auto
  .btn-black
    padding: 10px 30px
  .warning-info
    display: inline-block
    padding: 10px
    font-size: 14px
    border: 1px solid #DEDEDE;
    border-radius: 4px;
    margin-bottom: 20px
  .subNumber
    font-size: 32px
</style>



// WEBPACK FOOTER //
// ChooseDiscount.vue?53e9637e